<template>
  <div class="box">
    <div class="nav-box" :style="{ 'background-color': navColor }">
      <div class="nav">
        <div class="left">
          <img src="../assets/newImg/logo.png" alt="">
        </div>
        <div class="right">
          <template v-if="navlistShow">
            <div class="pc-nav" @click="changeNav(item)"
              :class="{ 'right-item': true, 'active': currentPath === item.src }" v-for="(item) in navList"
              :key="item.id">
              {{ item.title }}</div>
          </template>
          <div class="mobile-nav">
            <van-icon name="apps-o" size="30px" @click="menuBtn" />
          </div>
          <div class="new" style="margin-right: 20px;cursor: pointer;" @click="openDialog(1)">登录</div>
          <div class="new" style="margin-right: 20px;cursor: pointer;" @click="openDialog(0)">注册</div>
          <!-- <div class="new" style="cursor: pointer;" >新游下载</div> -->

          <!-- <div class="right-item">关于掌动</div>
      <div class="right-item">旗下产品</div>
      <div class="right-item">商务合作</div>
      <div class="right-item">联系我们</div> -->
        </div>


        <!-- 移动端导航菜单 -->
        <van-popup @close="popupClose" v-model="$store.state.navpopupShow" position="right" round
          :style="{ height: '26%' }">
          <div class="navMenu-box" style="color: black;">
            <div class="navMenu-item" v-for="(item, index) in navTextList" :key="index" @click="NavClick(item.src)">{{
              item.text }}</div>
            <!-- <div class="navMenu-item">加入我们</div>
        <div class="navMenu-item">联系我们</div> -->
          </div>
        </van-popup>
      </div>
      <el-dialog :title="flag ? '登录' : '注册'" :visible="centerDialogVisible" width="30%" center
        @close="centerDialogVisible = false" :modal="false">
        <el-form :model="form" :rules="rules" ref="formRef">
          <el-form-item prop="mobile">
            <el-input placeholder="请输入您的账号" v-model="form.mobile"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" show-password placeholder="请输入您的密码" v-model="form.password"></el-input>
          </el-form-item>
          <el-form-item v-if="!flag" prop="requirePassword">
            <el-input show-password placeholder="请您确认密码" v-model="form.requirePassword"></el-input>
          </el-form-item>
          <el-form-item>
            <div style="width: 100%; text-align: center;">
              <el-button  style="width: 100%;" round type="primary" @click="submit">{{ flag ? '登录' :
                '注册'
                }}</el-button>
            </div>

          </el-form-item>
          <el-form-item>
            <div style="width: 100%;text-align: center;cursor: pointer;">
              {{ flag ? '暂无账号，去申请' : '已有账号，去' }} <span style="color: #5fadff;" @click="flag = !flag">{{ flag ? '注册' :
                '登录' }}</span>?
            </div>
          </el-form-item>
        </el-form>

      </el-dialog>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    navList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const passValidator = (rule, value, callback)=>{
      if (value === this.form.password){
        callback()
      }else{
        callback(new Error('两次输入密码不一致!'));
      }
   }
    return {
      formRef: null,
      flag: true,
      centerDialogVisible: false,
      currentPath: '',
      windowWidth: document.documentElement.clientWidth,
      navlistShow: true,
      navColor: '#fff',
      timer: null,
      DialogVisible: true,
      form: {
        mobile: '',
        password: '',
        requirePassword: ''
      },
      navTextList: [
        {
          text: '首页',
          src: '/home'

        },
        // {
        //   text: '旗下游戏',
        //   src: '/game'

        // },
        {
          text: '加入我们',
          src: '/join'

        },
        {
          text: '联系我们',
          src: '/contact'
        }
      ],
      rules: {
        mobile: [
          { required: true, message: '请输入您的账号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确手机号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '密码为6位数字', trigger: 'blur' }
        ],
        requirePassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator:passValidator, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    downLoad(){
      // window.open('https://h5pay.zdjoys.com/download/#/','_blank')
    },
    openDialog(value) {
      this.centerDialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate()
        this.form={
          mobile: '',
          password: '',
          requirePassword: ''
        }
      })
      if (value) {
        this.flag = true
      } else {
        this.flag = false
      }
    },
    async submit() {
      await this.$refs.formRef.validate()
      this.centerDialogVisible = false
    },
    NavClick(src) {
      // this.navlistShow = false
      this.$store.commit('setNavpopupShow', false)
      this.$router.push(src)
    },
    changeNav(item) {
      this.$router.push(item.src)

      // console.log(index)
    },
    // 滚动页面时触发导航变色
    handleScroll() {
      // const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // console.log('scrollTop', scrollTop)
      // // 设置背景颜色的透明度
      // if (scrollTop) {
      //   this.navColor = '#ffffff'
      // } else if (scrollTop === 0) {
      //   this.navColor = 'transparent' // 设置回到顶部时，背景颜色为透明
      // }
    },
    // 滚动之前重置
    beforeDestroy() {
      // window.removeEventListener('scroll', this.handleScroll)
    },
    menuBtn() {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.$store.commit('setNavpopupShow', true)
      this.$store.commit('setIndex', -1)
    },
    popupClose() {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.$store.commit('setIndex', 0)
      }, 2000)
    }

  },
  mounted() {
    // window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
  },
  watch: {
    windowWidth(newVal, oldVal) {
      console.log('new', 'old')
    },
    // 监听路由变化
    '$route.path': function (newVal, oldVal) {
      // console.log(`new_path = ${newVal}, old_path = ${oldVal}`)
      this.currentPath = newVal
    }

  },
  created() {
    console.log('document.documentElement.clientWidth', document.documentElement.clientWidth)
    console.log(this.$route.fullPath)
  }
}
</script>

<style lang="scss" scoped>
// 移动端
@media (max-width: 992px) {
  .navMenu-box {
    text-align: center;
    padding: 0 20px;
    font-size: 15px;

    .navMenu-item {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid rgba(135, 135, 135, 0.2);
    }

    // display: flex;
    // flex-direction: column;
    // justify-content: center;
  }

  .nav-box {
    // width: 100%;
    // display: flex;
    // justify-content: center;
    position: fixed;
    z-index: 999999;
    width: 100% !important;

    .nav {

      display: flex;
      padding: 0 20px;
      height: 51px;
      width: 100% !important;
      justify-content: space-between;
      align-items: center;

      .left {
        width: 100px;
        height: 30px;
        // line-height: 50px;

        // background-color: aqua;
        img {
          // height:100%;
          width: 100%;
          display: block;
        }
      }
    }
  }

  .right {
    // line-height: 65px;
    .new{
      display: none;
    }
  }

  .pc-nav {
    display: none;
  }

  .mobile-nav {
    display: block;
    // line-height: 50px;
  }
}

// pc端
@media (min-width: 992px) {
  .box{
    display: flex;
    justify-content: center;
.pc-nav {
    display: block;
  }

  .mobile-nav {
    display: none;
  }

  .nav-box {
    width: 1400px;
    display: flex;
    justify-content: center;
    position: fixed;
    z-index: 999;
    // background-image: linear-gradient(to bottom,  #95f1f4,#fefefe,#4eefff);
    background: #4eefff;

    .nav {
      display: flex;

      padding: 0 100px;
      justify-content: space-between;
      height: 50px;
      // width: 100%;
      width: 1500px;
      // background-color: red !important;

      .left {
        // display: flex;
        // align-items: center;
        width: 150px;
        line-height: 45px;

        // background-color: aqua;
        img {
          // height:100%;
          width: 100%;
        }
      }

      .right {
        font-size: 16px;
        display: flex;
        align-items: center;
        font-weight: 400;
        font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
      }

      .right-item {
        position: relative;
        padding: 15px;
        cursor: pointer;
        margin-right: 60px;

        &:hover {
          color: #01bdb0;
        }

        &.active {
          color: #01bdb0;

          &::before {
            content: ' ';
            display: flex;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 3px;
            width: 40%;
            height: 4px;
            background-color: #01bdb0;
          }
        }
      }
    }
  }
  }
 
}
</style>
